import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Main from './layouts/Main'; // fallback for lazy pages
import './static/css/main.scss'; // All of our styles

const { PUBLIC_URL } = process.env;

// Every route - we lazy load so that each page can be chunked
// NOTE that some of these chunks are very small. We should optimize
// which pages are lazy loaded in the future.
// const About = lazy(() => import('./pages/About'));
// <Route path="/about" component={About} />

// const Contact = lazy(() => import('./pages/Contact'));
// <Route path="/contact" component={Contact} />

const Index = lazy(() => import('./pages/Index'));
const NotFound = lazy(() => import('./pages/NotFound'));
// const Projects = lazy(() => import('./pages/Projects'));
// add below in switch to reenable projects
// <Route path="/projects" component={Projects} />
const Photography = lazy(() => import('./pages/Photography'));
const Art = lazy(() => import('./pages/Art'));
const Blog = lazy(() => import('./pages/Blog'));
const Resume = lazy(() => import('./pages/Resume'));

// const Stats = lazy(() => import('./pages/Stats'));
// add below in switch to reenable projects
// <Route path="/stats" component={Stats} />

const App = () => (
  <BrowserRouter basename={PUBLIC_URL}>
    <Suspense fallback={<Main />}>
      <Switch>
        <Route exact path="/" component={Index} />
        <Route path="/photography" component={Photography} />
        <Route path="/art" component={Art} />
        <Route path="/blog" component={Blog} />
        <Route path="/resume" component={Resume} />
        <Route component={NotFound} status={404} />
      </Switch>
    </Suspense>
  </BrowserRouter>
);

export default App;
